<template>
  <div>
    <b-row class="border-bottom mb-2">
      <b-col>
        <h3>Object Manufacturer & Object Model</h3>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group
          label="Manufacturer"
          label-for="manufacturerInput"
        >
          <b-form-input
            id="manufacturerInput"
            v-model="newObject.info.manufacturer"
            placeholder="The company that produced the object"
          />
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group
          label="Manufacturer Serial Number"
          label-for="serialNumberInput"
        >
          <b-form-input
            id="serialNumberInput"
            v-model="newObject.info.serialNumber"
            placeholder="A serial number for a object is often on the bottom or back of the object."
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group
          label="Manufacturer Model"
          label-for="manufacturerModel"
        >
          <b-form-input
            id="manufacturerModel"
            v-model="newObject.info.model"
            placeholder="A model name is a combination of numbers and letters"
          />
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group
          label="Model Number"
          label-for="manufacturerModelNumber"
        >
          <b-form-input
            id="modelNumber"
            v-model="newObject.info.modelNumber"
            placeholder="A unique number given to each product and represents the product model"
          />
        </b-form-group>
      </b-col>
    </b-row>

  </div>
</template>

<script>

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  // BImg,
  // BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
    BRow,
    BCol,
    BFormGroup,
    // BImg,
    //  BCard,
  },
  props: {
    newObject: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setSelected(value) {
      if (value === null) {
        this.newObject.info.manufacturer = value
      } else if (value.id === undefined) {
        this.newObject.info.manufacturer = {
          name: value,
        }
      } else {
        this.newObject.info.manufacturer = value
      }
    },
  },
}
</script>

<style>

</style>
